import React from 'react'
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import Icons from "../../myIcon/Icons";

export default function KitchenStyles({ data, handleShow }) {

   const settingskey = {
      autoplay: true,
      speed: 1500,
      autoplaySpeed: 3000,
      infinite: true,
      arrows: false,
      dots: true,
      pauseOnHover: true,
      slidesToShow: 3,
      slidesToScroll: 1,

      responsive: [
         {
            breakpoint: 991,
            settings: {
               slidesToShow: 2,
            },
         },

         {
            breakpoint: 767,
            settings: {
               slidesToShow: 2,
            },
         },
          {
            breakpoint: 599,
            settings: {
               slidesToShow: 1,
            },
         },

         {
            breakpoint: 99999,
            settings: "unslick",
         },
      ],
   };

   return (
      <>
         <section className='kitchenstyles-section'>
            <div className='container'>
               <div className='row justify-content-center'>
                  <div className='col-lg-7'>
                     <h4 className='heading'>
                        {data.heading}
                     </h4>
                     <p>
                        {data.description}
                     </p>
                  </div>
               </div>

               <Slider {...settingskey} className='row kitchen-slider'>
                  {
                     data.styles.map((item, index) => (
                        <div
                           className='col-lg-4'
                           key={index}
                        >
                           <div className='kitchenstyles-cards'>

                              <img
                                 src={item.image}
                                 alt={item.title}
                                 className='img-responsive'
                              />

                              <span>
                                 {item.title}
                              </span>

                              <p>
                                 {item.description}
                              </p>

                              <Link onClick={handleShow} className="default-btn colored-btn">
                                 Get A Quote
                                 <Icons name="Longarrow_right" />
                              </Link>

                           </div>
                        </div>
                     ))
                  }
               </Slider>

            </div>
         </section>
      </>
   )
}